module.exports = __webpack_public_path__ + "img/source03_01.91e9c808.png";